
import React from "react";
import { Routes, Route } from "react-router-dom";
import TableView from "./pages/table_view";
import DiagramV2 from './pages/Diagram/diagram_view_v2';
import Home from "./pages/home";
import AddRecord from './pages/add_record';
import ChatWithAI from './pages/chat_with_ai';
import WorkflowBuilder from './components/WorkflowBuilder/WorkflowBuilder';
import IntegrationVisualization from './components/IntegrationVisualization/IntegrationVisualization';
import { RequiredAuth } from './components/RequiredAuth';
import { LoginCallback } from '@okta/okta-react';
import AddRecordBatch from "./components/addapi/AddRecordBatch";
import ApiDetails from "./pages/ApiDetails/api_detais";
import CompareVersions from "./pages/CompareVersions/CompareVersions";
import BetaLabsGate from './components/BetaLabsGate/BetaLabsGate';
import BetaLabsRequiredMessage from './components/BetaLabsRequiredMessage/BetaLabsRequiredMessage';
import { BETA_FEATURES } from './contexts/BetaLabsContext';
import SignOut from './pages/SignOut';
import ReleaseNotes from './pages/ReleaseNotes/ReleaseNotes';
import AdminPage from './pages/AdminPage';
import { AdminReportsPage } from './pages/AdminReportsPage';
import { SnapshotReportPage } from './pages/SnapshotReportPage';
import SpecAnalysisPage from './pages/SpecAnalysisPage';
import { CIPassRateReportsPage } from "./pages/CIPassRateReportsPage";

const AppRoutes: React.FC = () => {
    return (
        <Routes>
            {/* Wrap routes with RequiredAuth */}
            <Route element={<RequiredAuth />}>
                <Route path="/" element={<Home />} />
                <Route path="/table-view" element={<TableView />} />
                <Route path="/diagram-v2" element={<DiagramV2 />} />
                <Route path="/chat-with-ai" element={<ChatWithAI />} />
                <Route path="/add-record" element={<AddRecord />} />
                <Route path="/add-record/batch" element={<AddRecordBatch />} />
                <Route path="/api-details/:id" element={<ApiDetails />} />
                <Route path="/compare/:apiId" element={<CompareVersions />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/reports" element={<AdminReportsPage />} />
                <Route path="/admin/reports/snapshots/:snapshotId" element={<SnapshotReportPage />} />
                <Route path="/admin/ci-pass-rates" element={<CIPassRateReportsPage />} />
                <Route path="/analysis/:apiId" element={<SpecAnalysisPage />} />
                <Route path="/spec-analysis/:apiId" element={<SpecAnalysisPage />} />
                <Route path="/release-notes" element={<ReleaseNotes />} />
                <Route path="/release-notes/article/:articleId" element={<ReleaseNotes />} />
                <Route 
                    path="/workflow-builder" 
                    element={
                        <BetaLabsGate 
                            featureKey={BETA_FEATURES.INTEGRATION_MAPPER}
                            fallback={<BetaLabsRequiredMessage />}
                        >
                            <WorkflowBuilder />
                        </BetaLabsGate>
                    } 
                />
                <Route 
                    path="/integration-visualization" 
                    element={
                        <BetaLabsGate 
                            featureKey={BETA_FEATURES.INTEGRATION_ECOSYSTEM}
                            fallback={<BetaLabsRequiredMessage />}
                        >
                            <IntegrationVisualization />
                        </BetaLabsGate>
                    } 
                />
            </Route>
            <Route path="/authorization-code/callback" element={<LoginCallback />} />
            <Route path="/sign-out" element={<SignOut />} />
        </Routes>
    );
};

export default AppRoutes;
